import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchUserDashboard } from '../../store/slices/dashboardSlice';
import { StatCard } from './StatCard';
import { useNavigate } from 'react-router-dom';

export const UserDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { userDashboard, loading, error } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    dispatch(fetchUserDashboard());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-gray-600 dark:text-gray-400">Yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
        <p className="text-red-700 dark:text-red-300">{error}</p>
      </div>
    );
  }

  if (!userDashboard) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fadeIn">
      <div className="animate-slideUp" style={{ animationDelay: '0ms' }}>
        <StatCard
          title="Toplam Talepler"
          value={userDashboard.totalRequests}
          icon={<i className="fas fa-file-alt"></i>}
          color="blue"
          onClick={() => navigate('/request-tracking')}
        />
      </div>
      <div className="animate-slideUp" style={{ animationDelay: '100ms' }}>
        <StatCard
          title="Taslak Talepler"
          value={userDashboard.draftRequests}
          icon={<i className="fas fa-file"></i>}
          color="gray"
          onClick={() => navigate('/create-request')}
        />
      </div>
      <div className="animate-slideUp" style={{ animationDelay: '200ms' }}>
        <StatCard
          title="Bekleyen Talepler"
          value={userDashboard.pendingRequests}
          icon={<i className="fas fa-clock"></i>}
          color="yellow"
          onClick={() => navigate('/request-tracking')}
        />
      </div>
      <div className="animate-slideUp" style={{ animationDelay: '300ms' }}>
        <StatCard
          title="Onaylanan Talepler"
          value={userDashboard.approvedRequests}
          icon={<i className="fas fa-check-circle"></i>}
          color="green"
          onClick={() => navigate('/request-tracking')}
        />
      </div>
      <div className="animate-slideUp" style={{ animationDelay: '400ms' }}>
        <StatCard
          title="Reddedilen Talepler"
          value={userDashboard.rejectedRequests}
          icon={<i className="fas fa-times-circle"></i>}
          color="red"
          onClick={() => navigate('/request-tracking')}
        />
      </div>
      <div className="animate-slideUp" style={{ animationDelay: '500ms' }}>
        <StatCard
          title="Son 7 Gün"
          value={userDashboard.recentRequests}
          icon={<i className="fas fa-calendar-alt"></i>}
          color="blue"
          onClick={() => navigate('/request-tracking')}
        />
      </div>
    </div>
  );
};
